import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import holeInOneRuleService from "./holeInOneRuleService";

export const getHoleInOneRule = createAsyncThunk(
  "hole-in-one-rule/get-hole-in-one-rule",
  async (data, thunkAPI) => {
    try {
      return await holeInOneRuleService.getHoleInOneRule(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateHoleInOneRule = createAsyncThunk(
  "hole-in-one-rule/update-hole-in-one-rule",
  async (data, thunkAPI) => {
    try {
      return await holeInOneRuleService.updateHoleInOneRule(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const initialState = {
  holeInOneRule: {},
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
  updating: false,
  isUpdateSuccess: false,
};
export const holeInOneRuleSlice = createSlice({
  name: "holeInOneRule",
  initialState,
  reducers: {
    initRule: (state) => {
      state.isError = false;
      state.isLoading = false;
      state.isSuccess = false;
      state.message = "";
      state.updating = false;
      state.isUpdateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getHoleInOneRule.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getHoleInOneRule.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.holeInOneRule = action.payload;
        state.isUpdateSuccess = false;
      })
      .addCase(getHoleInOneRule.rejected, (state, action) => {
        state.isLoading =   false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateHoleInOneRule.pending, (state, action) => {
        state.updating = true;
        state.isUpdateSuccess = false;
      })
      .addCase(updateHoleInOneRule.rejected, (state, action) => {
        state.isError = true;
        state.updating = false;
        state.message = action.payload;
      })
      .addCase(updateHoleInOneRule.fulfilled, (state, action) => {
        state.updating = false;
        state.isUpdateSuccess = true;
      })
  },
});
export default holeInOneRuleSlice.reducer;
export const { initRule } = holeInOneRuleSlice.actions;